import type { MouseEvent } from 'react';
import { Button } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';
import { CheckCircle, X } from 'lucide-react';

interface ApproveRejectButtonsProps {
  onApprove: (e: MouseEvent) => void;
  onReject: (e: MouseEvent) => void;
  disabled?: boolean;
  /** Controla apenas o tamanho do ícone (ex: "w-4 h-4"). O espaçamento mr-2 é sempre aplicado. */
  iconSize?: string;
}

export function ApproveRejectButtons({
  onApprove,
  onReject,
  disabled = false,
  iconSize = 'w-4 h-4'
}: ApproveRejectButtonsProps) {
  const { t } = useTranslate();

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        border="default"
        disabled={disabled}
        onClick={onReject}
        className="flex items-center bg-white"
        style={{ color: 'var(--error-default, #FF3236)' }}>
        <X
          className={`mr-2 ${iconSize}`}
          style={{ color: 'var(--error-default, #FF3236)' }}
        />
        {t('common.buttons.reject', 'Reject')}
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        border="default"
        disabled={disabled}
        onClick={onApprove}
        className="flex items-center bg-white"
        style={{ color: 'var(--success-default, #44AC21)' }}>
        <CheckCircle
          className={`mr-2 ${iconSize}`}
          style={{ color: 'var(--success-default, #44AC21)' }}
        />
        {t('common.approve', 'Approve')}
      </Button>
    </>
  );
}
